import React, { useContext } from 'react';
import { AuthContext, Card, Form } from 'components/lib';

export function LogoUpload(props) {

    const context = useContext(AuthContext);

    const titleStyle = {
        textAlign: 'center',
        color: 'rgb(99 99 172 / var(--tw-text-opacity))',
        fontWeight: '600',
        marginBottom: '1.5rem',
        fontSize: "1.3rem",
        lineHeight: '2rem'
    }

    return (
        <Card
            restrictWidth
            restrictHeight
            center
        >
            <h1 id='title' style={titleStyle}>{props.t('auth.signup.logoUpload.header')}</h1>
            <Form
                buttonText={props.t('auth.signup.logoUpload.form.button')}
                url='/api/user/upload'
                method='POST'
                inputs={{
                    org_logo: {
                        type: 'file',
                        max: 1,
                        required: true,
                        maxFileSize: 60,
                        onlyImage: true,
                        validUserName: true,
                        disabled: true,
                    }
                }}
                callback={() => {
                    // Update the org logo upload status.
                    context.update({ is_org_logo_upload_required: false });
                    window.location = '/navigate';
                }}
            />
            <button
                style={{ color: '#3B82F6', textDecoration: 'underline' }}
                onClick={() => {
                    context.signout();
                }}
            >
                {props.t('auth.signup.logoUpload.button')}
            </button>
        </Card>
    );
}
